<template>
<div class="chapter">
<div class="inner_page">
<div class="boxd">
<p class="dedih"><b>Dedication</b></p>
<p class="dedi">This book is dedicated to my mother, Jennie Priven. You will always be my greatest teacher.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedi.vue?c7f2ebf4